/* ===========================================================================
   SALON homepage refinements (appended)
   1) open into the Scottish castle by default (2026-10-29, was the Enchanted Forest)
   2) real backdrop thumbnails on the Rooms menu tiles
   3) vibrant, true-colour artwork on the walls (match the detail view)
   4) lighter always-on text (SKU + edition line live in the click-through detail)
   =========================================================================== */
(function(){
"use strict";

/* ---- (1) default landing room -> the Scottish castle. Every visitor opens there once after this change
   (flag salon3d_castle_default), then their own last room is remembered again. ---- */
try{
  if(!localStorage.getItem('salon3d_castle_default') && window.Shop && window.Shop.state){
    window.Shop.state.room='castle';
    if(typeof window.Shop.save==='function') window.Shop.save();
    localStorage.setItem('salon3d_castle_default','1');
  }
}catch(e){
  try{ if(window.Shop && window.Shop.state) window.Shop.state.room='castle'; }catch(_){}
}

/* ---- (4) declutter the always-visible commerce bar (detail still on click) ---- */
try{
  var st=document.createElement('style');
  st.textContent='.combar .eyebrow .sku{display:none!important}.combar .edtxt{display:none!important}';
  document.head.appendChild(st);
}catch(e){}

/* ---- (2) backdrop thumbnails for each Rooms-menu tile ---- */
var _thumbs={};
function paintThumbs(){
  var grid=document.querySelector('.roomgrid'); if(!grid) return;
  var cards=grid.querySelectorAll('.roomcard[data-room]');
  for(var i=0;i<cards.length;i++){
    var card=cards[i], id=card.getAttribute('data-room');
    var mini=card.querySelector('.mini'); if(!mini || mini.getAttribute('data-thumbed')) continue;
    var url=_thumbs[id];
    if(url===undefined){
      url='';
      try{
        var r=(window.ROOM3D||{})[id];
        if(r && window.Backdrops && typeof window.Backdrops.paint==='function'){
          var cv=window.Backdrops.paint(id,r);
          if(cv && cv.toDataURL) url=cv.toDataURL('image/jpeg',0.7);
        }
      }catch(e){}
      _thumbs[id]=url;
    }
    if(url){
      mini.style.backgroundImage='url('+url+')';
      mini.style.backgroundSize='cover';
      mini.style.backgroundPosition='center';
      mini.setAttribute('data-thumbed','1');
    }
  }
}
(function watchGrid(){
  var grid=document.querySelector('.roomgrid');
  if(!grid){ setTimeout(watchGrid,250); return; }
  try{ new MutationObserver(function(){ paintThumbs(); }).observe(grid,{childList:true}); }catch(e){}
  paintThumbs();
})();

/* ---- (3) keep wall artwork vibrant / true-colour, self-correcting ---- */
function ensureVibrant(){
  var GAL=window.GAL; if(!GAL || !GAL.artGroups) return;
  for(var i=0;i<GAL.artGroups.length;i++){
    var g=GAL.artGroups[i], mesh=g && g.userData && g.userData.artMesh;
    if(!mesh) continue;
    var m=mesh.material; if(!m || !m.map) continue;
    if(m.emissiveMap!==m.map || m.emissiveIntensity<0.5){
      m.emissiveMap=m.map;
      if(m.emissive && m.emissive.setRGB) m.emissive.setRGB(1,1,1);
      m.emissiveIntensity=0.82;
      m.needsUpdate=true;
    }
  }
}
setInterval(ensureVibrant,600);

})();
